(function () {
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var pad = function (n) { return (n < 10 ? '0' : '') + n; };
  var DAYS = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
  var MON = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];

  var prod = $('#pp-product');
  var moneyFormat = (prod && prod.dataset.moneyFormat) || '${{amount}}';
  function money(cents, noTrailing) {
    var v = (cents / 100);
    var withDec = v.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    var amt = noTrailing && cents % 100 === 0 ? v.toLocaleString('en-US', { maximumFractionDigits: 0 }) : withDec;
    return moneyFormat
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, withDec.replace(/,/g, '#').replace('.', ',').replace(/#/g, '.'))
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(v).toLocaleString('en-US'))
      .replace(/\{\{\s*amount\s*\}\}/, amt);
  }

  /* dates */
  var now = new Date(), tm = new Date(now); tm.setDate(now.getDate() + 1);
  var promo = $('#pp-promo'), endAt = null;
  if (promo && promo.dataset.saleEnd) { var d0 = new Date(promo.dataset.saleEnd); if (!isNaN(d0) && d0 > now) endAt = d0; }
  if (endAt) {
    $$('.pp-ends').forEach(function (e) { e.hidden = false; });
    var sameDay = endAt.toDateString() === now.toDateString();
    $$('[data-wd]').forEach(function (e) { e.textContent = sameDay ? 'Today' : DAYS[endAt.getDay()] + ', '; });
    $$('[data-md]').forEach(function (e) { e.textContent = sameDay ? '' : MON[endAt.getMonth()].slice(0, 3) + ' ' + endAt.getDate(); });
  } else {
    var fp0 = $('#float-pill'); if (fp0) fp0.parentNode.removeChild(fp0);
  }
  $$('[data-ship]').forEach(function (e) { e.textContent = DAYS[tm.getDay()] + ', ' + MON[tm.getMonth()].slice(0, 3) + ' ' + tm.getDate(); });
  $$('[data-cur-month]').forEach(function (e) { e.textContent = MON[now.getMonth()]; });
  $$('[data-prev-month]').forEach(function (e) { e.textContent = MON[(now.getMonth() + 11) % 12]; });
  $$('[data-batch-text]').forEach(function (e) {
    e.textContent = e.textContent.replace(/\[month\]/g, MON[now.getMonth()]).replace(/\[next\]/g, MON[(now.getMonth() + 1) % 12]);
  });

  /* countdown to the real sale end */
  var tid = null;
  function tick() {
    if (!endAt) return;
    var n = new Date(), d = Math.max(0, Math.floor((endAt - n) / 1000));
    if (d <= 0) { $$('.pp-ends').forEach(function (e) { e.hidden = true; }); var fp1 = $('#float-pill'); if (fp1) fp1.parentNode.removeChild(fp1); if (tid) clearInterval(tid); return; }
    var h = Math.floor(d / 3600), m = Math.floor(d % 3600 / 60), s = d % 60;
    $$('[data-timer]').forEach(function (e) { e.textContent = pad(h) + ':' + pad(m) + ':' + pad(s); });
    $$('[data-h]').forEach(function (e) { e.textContent = pad(h); });
    $$('[data-m]').forEach(function (e) { e.textContent = pad(m); });
    $$('[data-s]').forEach(function (e) { e.textContent = pad(s); });
  }
  tick(); if (endAt) tid = setInterval(tick, 1000);

  /* mobile menu */
  var mb = $('#menu-btn'), nav = $('#nav');
  if (mb && nav) mb.addEventListener('click', function () { var o = nav.classList.toggle('open'); mb.setAttribute('aria-expanded', o); });

  /* gallery */
  var slides = $$('.g-slide'), thumbs = $$('.g-thumb'), dots = $('#g-dots'), gi = 0;
  if (dots && slides.length > 1) slides.forEach(function () { dots.appendChild(document.createElement('i')); });
  function show(i) {
    if (!slides.length) return;
    gi = (i + slides.length) % slides.length;
    slides.forEach(function (s, k) { s.classList.toggle('on', k === gi); if (k !== gi) $$('video', s).forEach(function (v) { v.pause(); }); });
    var start = Math.min(Math.max(gi - 2, 0), Math.max(thumbs.length - 5, 0));
    thumbs.forEach(function (t, k) { t.classList.toggle('on', k === gi); t.style.display = (k >= start && k < start + 5) ? '' : 'none'; });
    if (dots) $$('i', dots).forEach(function (t, k) { t.classList.toggle('on', k === gi); });
  }
  $$('[data-g]').forEach(function (b) { b.addEventListener('click', function () { show(gi + (+b.dataset.g)); }); });
  thumbs.forEach(function (t) { t.addEventListener('click', function () { show(+t.dataset.thumb); }); });
  if (slides.length < 2) $$('.g-arrow').forEach(function (a) { a.style.display = 'none'; });
  show(0);
  var gm = $('.g-main'), tx = null;
  if (gm) {
    gm.addEventListener('touchstart', function (e) { tx = e.touches[0].clientX; }, { passive: true });
    gm.addEventListener('touchend', function (e) { if (tx === null) return; var dx = e.changedTouches[0].clientX - tx; if (Math.abs(dx) > 40) show(gi + (dx < 0 ? 1 : -1)); tx = null; });
  }

  /* Kaching-style bundle bars */
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var qty = $('#pp-qty'), pid = $('#pp-id'), P = null;
  try { var pj = $('#pp-product-json'); P = pj ? JSON.parse(pj.textContent) : null; } catch (e) { P = null; }
  function findVariant(vals) {
    if (!P || !P.variants) return null;
    for (var i = 0; i < P.variants.length; i++) {
      var v = P.variants[i], ok = true;
      for (var j = 0; j < vals.length; j++) { if (v.options[j] !== vals[j]) { ok = false; break; } }
      if (ok) return v;
    }
    return null;
  }
  function rowVariants(bar) { return $$('.kb-vrow', bar).map(function (r) { return findVariant($$('select', r).map(function (s) { return s.value; })); }); }
  function updateBar(bar) {
    var rows = rowVariants(bar); if (!rows.length || !prod) return;
    var n = +bar.dataset.qty || 1, keep = +bar.dataset.keep || 100, free = +bar.dataset.free || 0;
    var p = 0, c = 0, ok = true, list = [];
    rows.forEach(function (v) { if (!v || !v.available) { ok = false; return; } p += v.price; list.push(v.price); c += (v.compare_at_price > v.price ? v.compare_at_price : v.price); });
    bar.classList.toggle('na', !ok);
    if (!ok) return;
    list.sort(function (x, y) { return x - y; });
    for (var f = 0; f < free && f < list.length - 1; f++) p -= list[f];
    var tp = Math.floor(p * keep / 100), a = $('[data-tier-price]', bar), b = $('[data-tier-cmp]', bar);
    if (a) a.textContent = money(tp);
    if (b) { b.textContent = money(c); b.hidden = !(c > tp); }
    var ea = $('[data-tier-each]', bar), sv = $('[data-tier-save]', bar);
    if (ea) ea.textContent = money(Math.floor(tp / n));
    if (sv) sv.textContent = money(Math.max(0, c - tp));
    if (bar.classList.contains('on') && pid && rows[0]) pid.value = rows[0].id;
  }
  function pickBar(bar) {
    $$('.kb-bar').forEach(function (x) { x.classList.remove('on'); x.setAttribute('aria-checked', 'false'); });
    bar.classList.add('on'); bar.setAttribute('aria-checked', 'true');
    if (qty) qty.value = bar.dataset.qty;
    syncGifts(+bar.dataset.qty || 1);
    updateBar(bar);
  }
  function syncGifts(n) {
    $$('.fg-card[data-min-qty]').forEach(function (g) { g.classList.toggle('locked', (+g.dataset.minQty || 1) > n); });
  }
  $$('.kb-bar').forEach(function (bar) {
    bar.addEventListener('click', function (e) { if (e.target.closest('.kb-vars')) return; pickBar(bar); });
    bar.addEventListener('keydown', function (e) { if (e.target !== bar) return; if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); pickBar(bar); } });
    $$('.kb-opt', bar).forEach(function (s) { s.addEventListener('change', function () { updateBar(bar); }); });
    updateBar(bar);
  });
  var form = $('#pp-form');
  if (form) {
    form.addEventListener('submit', function (e) {
      var bar = $('.kb-bar.on');
      if (!bar || !$$('.kb-vrow', bar).length) return; /* single-variant product: native submit with quantity */
      e.preventDefault();
      var counts = {};
      rowVariants(bar).forEach(function (v) { if (v && v.available) counts[v.id] = (counts[v.id] || 0) + 1; });
      var items = Object.keys(counts).map(function (k) { return { id: +k, quantity: counts[k] }; });
      if (!items.length) return;
      fetch(root + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: items }) })
        .then(function (r) { if (!r.ok) throw new Error('add failed'); window.location.href = root + 'cart'; })
        .catch(function () { form.submit(); });
    });
  }
  var vs = $('#pp-variant');
  if (vs && prod) {
    vs.addEventListener('change', function () {
      var opt = vs.options[vs.selectedIndex], p = +opt.dataset.price, c = +opt.dataset.cmp;
      var base = c > p ? c : p;
      $('#pp-price').textContent = money(p);
      var pc = $('#pp-cmp'); if (pc) { pc.hidden = !(c > p); pc.textContent = money(c); }
      $$('.kb-bar').forEach(function (bar) {
        var n = +bar.dataset.qty || 1, tp = Math.floor(p * (n - (+bar.dataset.free || 0)) * (+bar.dataset.keep || 100) / 100), tc = base * n;
        var a = $('[data-tier-price]', bar), b = $('[data-tier-cmp]', bar);
        if (a) a.textContent = money(tp);
        if (b) { b.textContent = money(tc); b.hidden = !(tc > tp); }
      });
      var sp = $('#s-price'); if (sp) sp.textContent = money(p);
      var avail = opt.dataset.available === 'true';
      $$('#atc-main, .s-btn').forEach(function (btn) { btn.disabled = !avail; });
      if (window.history && window.history.replaceState) {
        var u = new URL(window.location.href); u.searchParams.set('variant', opt.value); window.history.replaceState({}, '', u.toString());
      }
    });
  }

  /* looping section videos: play only while on screen */
  var loops = $$('.media.is-video video[autoplay]');
  if (loops.length && 'IntersectionObserver' in window) {
    var vio = new IntersectionObserver(function (es) {
      es.forEach(function (en) { var v = en.target; if (en.isIntersecting) { var p = v.play(); if (p && p.catch) p.catch(function () {}); } else { v.pause(); } });
    }, { threshold: 0.25 });
    loops.forEach(function (v) { v.muted = true; vio.observe(v); });
  }

  /* cart count */
  var cc = $('#cart-count');
  function setCount(n) { if (!cc) return; cc.textContent = n; cc.hidden = !n; }

  /* add-ons */
  $$('.up').forEach(function (row) {
    var sel = $('.up-var', row), btn = $('.up-add', row);
    if (sel && btn) {
      sel.addEventListener('change', function () {
        var o = sel.options[sel.selectedIndex], p = +o.dataset.price, c = +o.dataset.cmp;
        btn.dataset.variant = o.value;
        var bp = $('[data-up-price]', row), bc = $('[data-up-cmp]', row), bo = $('[data-up-off]', row);
        if (bp) bp.textContent = money(p);
        if (bc) { bc.textContent = c > p ? money(c) : ''; }
        if (bo) { bo.hidden = !(c > p); if (c > p) bo.textContent = Math.floor((c - p) * 100 / c) + '% OFF'; }
      });
    }
    if (btn && btn.dataset.variant) {
      btn.addEventListener('click', function () {
        if (btn.classList.contains('added') || btn.disabled) return;
        btn.disabled = true; var label = btn.textContent; btn.textContent = '…';
        fetch((window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') + 'cart/add.js', {
          method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: [{ id: +btn.dataset.variant, quantity: 1 }] })
        }).then(function (r) { if (!r.ok) throw new Error('add failed'); return fetch((window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') + 'cart.js'); })
          .then(function (r) { return r.json(); })
          .then(function (cart) { setCount(cart.item_count); btn.textContent = 'Added'; btn.classList.add('added'); btn.disabled = false; })
          .catch(function () { btn.textContent = label; btn.disabled = false; });
      });
    }
  });

  /* impact counters */
  var imp = $('#impact'), fired = false;
  if (imp && 'IntersectionObserver' in window && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    $$('[data-count]', imp).forEach(function (el) { el.textContent = (+el.dataset.count).toLocaleString('en-AU'); });
    new IntersectionObserver(function (es) {
      if (!es[0].isIntersecting || fired) return; fired = true;
      $$('[data-count]', imp).forEach(function (el) {
        var t = +el.dataset.count, s = Math.round(t * 0.85), st = performance.now();
        (function step(ts) { var p = Math.min((ts - st) / 1400, 1), e = 1 - Math.pow(1 - p, 3); el.textContent = Math.round(s + (t - s) * e).toLocaleString('en-AU'); if (p < 1) requestAnimationFrame(step); })(st);
      });
    }, { threshold: 0.4 }).observe(imp);
  } else if (imp) {
    $$('[data-count]', imp).forEach(function (el) { el.textContent = (+el.dataset.count).toLocaleString('en-AU'); });
  }

  /* floating pill, sticky ATC, back to top */
  var satc = $('#s-atc'), top = $('#to-top'), mainBtn = $('#atc-main');
  function onScroll() {
    var y = window.scrollY || 0, pill = $('#float-pill');
    if (pill) pill.classList.toggle('show', y > 140);
    if (satc && mainBtn) satc.classList.toggle('show', mainBtn.getBoundingClientRect().bottom < 0);
    if (top) top.classList.toggle('show', y > 900);
  }
  window.addEventListener('scroll', onScroll, { passive: true }); onScroll();
  if (top) top.addEventListener('click', function () { window.scrollTo({ top: 0, behavior: 'smooth' }); });

  /* reviews */
  var more = $('#rv-more'), ms = $('#masonry');
  if (more && ms) more.addEventListener('click', function () { ms.classList.add('all'); more.parentNode.hidden = true; });
  $$('.rc-btn').forEach(function (b) {
    b.addEventListener('click', function () {
      if (b.dataset.d) return; b.dataset.d = 1;
      var h = b.previousElementSibling, n = parseInt(h.textContent, 10) || 0;
      h.textContent = (n + 1) + ' people found this helpful'; b.style.borderColor = 'var(--ink)';
    });
  });

  /* community carousel */
  var ct = $('#c-track'), cd = $('#c-dots');
  if (ct && ct.firstElementChild) {
    $$('[data-c]').forEach(function (b) { b.addEventListener('click', function () { ct.scrollBy({ left: (+b.dataset.c) * (ct.firstElementChild.offsetWidth + 20), behavior: 'smooth' }); }); });
    ct.addEventListener('scroll', function () {
      var w = ct.firstElementChild.offsetWidth + 20, k = Math.round(ct.scrollLeft / w);
      if (cd) $$('i', cd).forEach(function (d, j) { d.classList.toggle('on', j === k); });
    }, { passive: true });
  }
})();
